import {Marker} from "react-leaflet";
import React from "react";

const hash = window.location.hash;

export const AutoOpenMarker = props => {
    const initMarker = ref => {
        if (ref && hash === '#' + props.autoOpenId) {
            window.setTimeout(() => {
                ref.openPopup();
            }, 0);
        }
    }
    return <Marker ref={initMarker} {...props}/>
}

